import { Component, Input, OnInit } from '@angular/core';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { ModuleManager } from 'src/shared/models/module-manager';
import { IAFrustrationDataset } from '../../modules/ia-frustration/ia-frustration.models';
import { IAFrustrationService } from '../../modules/ia-frustration/ia-frustration.service';

@Component({
    selector: 'cv-ia-frustration-settings',
    templateUrl: './ia-frustration-settings.component.html',
    styleUrls: ['./ia-frustration-settings.component.scss']
})
export class IaFrustrationSettingsComponent implements OnInit {

    @Input() moduleManager: ModuleManager;

    // Currently selected dataset
    frustrationDataset: IAFrustrationDataset;
    // Full list for use with the front end
    frustrationDatasetList: Array<IAFrustrationDataset> = new Array<IAFrustrationDataset>();

    constructor(
        private service: IAFrustrationService,
        private cvLocalizationService: CVLocalizationService
    ) { }

    async ngOnInit(): Promise<void> {
        const awaiters: [Promise<Map<string, string>>, Promise<IAFrustrationDataset[]>] = [
            this.cvLocalizationService.GetSection("Frustration_Widget"),
            this.service.LoadFrustrationDatasets(this.moduleManager.getModuleKey())
        ];
        const awaitResults = await Promise.all(awaiters);
        this.frustrationDatasetList = awaitResults[1] as Array<IAFrustrationDataset> ?? new Array<IAFrustrationDataset>();

        this.moduleManager.addSetting({
            name: 'frustrationDataset',
            getValue: () => this.frustrationDataset,
            onSettingLoaded: value => {
                this.frustrationDataset = value;
            },
            defaultValue: undefined,
        });

        // tell module manager that you have finished adding your settings
        this.moduleManager.customSettingsAdded = true;
    }

    public getFrustationContext() {
        return this.frustrationDataset == null ?
            this.cvLocalizationService.getCachedText('Frustration_Widget', 'Not_Set', 'Not Set') :
            this.frustrationDataset.DatasetName;
    }

    public datasetComparer(a: IAFrustrationDataset, b: IAFrustrationDataset) {
        if (a && b)
            return a.DatasetId === b.DatasetId;
        return false;
    }
}


